import React from "react";
import AppStore from "../../../public/static/images/svg/AppStore.svg";
import PlayStore from "../../../public/../public/static/images/svg/PlayStore.svg";

export const DownloadApp = () => {
  const handleDownload = (e) => {
    const downloadApp = {
      AppStore: "https://hcid.onelink.me/By7i/HCPayWebsite",
      GooglePlay: "https://hcid.onelink.me/By7i/HCPayWebsite"
    };
    window.open(`${downloadApp[e]}`, "_blank");
  };

  return (
    <div className="download-app-wrapper">
      <img src={PlayStore} onClick={() => handleDownload("GooglePlay")}></img>
      <img src={AppStore} onClick={() => handleDownload("AppStore")}></img>
      <style jsx>{`
        .download-app-wrapper {
          display: flex;
          justify-content: center;
        }
        img {
          width: 100%;
          max-width: 183px;
          min-width: 105px;
          min-height: 32px;
          margin: 16px 25px;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};
